import(/* webpackMode: "eager" */ "/app/src/app/[locale]/solutions/industry-4-0/page.tsx");
